import { Navigate, useParams } from "react-router-dom";

import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useCanManageCareerPlanBool,
  useCanViewCareerPlanBool,
  useRequireCapability
} from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";

import CareerPlanOnboardingForm from "./_CareerPlanOnboardingForm";

export default function CareerPlanOnboardingPage() {
  useRequireCapability({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewCareerPlan
  });
  const { pgaId } = useParams();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded: capabilitiesLoaded } = useCapabilities();
  const canViewCareerPlan = useCanViewCareerPlanBool();
  const canManageCareerPlan = useCanManageCareerPlanBool();
  const careerTargetsEnabled = flags["pga-career-targets"] === true;
  const careerPlansEnabled = flags["pga-career-plan"] === true;

  if (!flagsLoaded || !capabilitiesLoaded) return null;
  if (!pgaId) return null;
  if (!careerTargetsEnabled || !careerPlansEnabled || !canViewCareerPlan || !canManageCareerPlan) {
    return <Navigate to={`/people/${pgaId}/career/career-profile`} replace />;
  }

  return <CareerPlanOnboardingForm pgaId={pgaId} />;
}
